const DetectDragOverDirective = () => ({
  require: 'ngModel',
  restrict: 'A',
  link: ($scope, el, attrs, ngModel) => {
    el.bind('dragenter', () => {
      ngModel.$setViewValue(true);
      $scope.$apply();
    });

    el.bind('dragleave', (event) => {
      if (el[0] && !el[0].contains(event.relatedTarget)) {
        ngModel.$setViewValue(false);
        $scope.$apply();
      }
    });

    el.bind('drop', (event) => {
      event.stopPropagation();
      ngModel.$setViewValue(false);
      $scope.$apply();
    });

    el.bind('dragover', (event) => {
      event.stopPropagation();
    });
  },
});

export default DetectDragOverDirective;
